// Import the imageCompression function from the 'browser-image-compression' library
import imageCompression from "browser-image-compression";

export async function compressImage(imageFile) {
  // Define the options for the image compression
  const options = {
    // Set the maximum size of the compressed image to 2MB
    maxSizeMB: 2,
    // Uncomment the line below if you want to set a maximum width or height for the image
    // maxWidthOrHeight: 1920,
    // Enable the use of Web Workers for better performance
    useWebWorker: true,
  };
  try {
    // Attempt to compress the image file using the specified options
    const compressedFile = await imageCompression(imageFile, options);
    // If the compression is successful, return the compressed file
    return compressedFile;
  } catch (error) {
    // If an error occurs during the compression process, throw the error
    throw error;
  }
}
